import React, { useState } from "react";
import { useParams } from "react-router";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { Button, PageHeading } from "../../components";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import DocumentInfoBox from "./components/DocumentInfoBox";
import DocumentFile from "./components/DocumentFile";
import { useGetDocumentDetailQuery } from "./queries";
import { downloadURI } from "../../helpers/fileHelper";
import { MAIN_IMAGE_ROOT } from "../../app_config";
import DocumentSendByEmailModal from "./components/DocumentSendByEmailModal";

type DocumentPageParams = "documentId";

const DocumentPage: React.FC = (): React.ReactElement => {
  const { t } = useCustomTranslation();
  const params = useParams<DocumentPageParams>();

  const [showSendByEmailModal, setShowSendByEmailModal] = useState(false);

  const query = useGetDocumentDetailQuery(params.documentId);

  const documentDetail = query.data;

  return (
    <ContentWrapper
      loading={query.isLoading || !documentDetail}
      htmlTitle={documentDetail?.name}
    >
      {documentDetail && (
        <>
          <div className="mb-8 flex flex-wrap items-center justify-between">
            <PageHeading
              title={documentDetail.name}
              backButtonPath={`orders/${documentDetail.orderId}`}
            />
            <div className="flex flex-wrap items-center gap-3">
              <Button
                label={t("send_by_email")}
                icon="mail"
                size="small"
                onClick={() => setShowSendByEmailModal(true)}
              />
              <Button
                label={t("print")}
                icon="print"
                size="small"
                onClick={() =>
                  window.open(`${MAIN_IMAGE_ROOT}${documentDetail.publicUrl}`)
                }
              />
              <Button
                label={t("download")}
                icon="file-download"
                size="small"
                onClick={() =>
                  downloadURI(
                    `${MAIN_IMAGE_ROOT}${documentDetail.publicUrl}`,
                    documentDetail.name,
                  )
                }
              />
            </div>
          </div>
          <DocumentInfoBox documentDetail={documentDetail} />
          <DocumentFile url={documentDetail.publicUrl} />
          <DocumentSendByEmailModal
            document={documentDetail}
            isOpen={showSendByEmailModal}
            onClose={() => setShowSendByEmailModal(false)}
          />
        </>
      )}
    </ContentWrapper>
  );
};

export default DocumentPage;
